import PropTypes from 'prop-types'
import React from 'react'

import AnchorNewTab from '../AnchorNewTab'
import NoContextLink from '../NoContextLink'

const MobileNavFooterLink = ({data: {title, toSpa, url}}) => (
  <li key={title} className="mobile-nav-footer-link-item">
    {toSpa ? (
      <NoContextLink className="mobile-nav-footer-link" to={url}>
        {title}
      </NoContextLink>
    ) : (
      <AnchorNewTab className="mobile-nav-footer-link" href={url}>
        {title}
      </AnchorNewTab>
    )}
  </li>
)

MobileNavFooterLink.propTypes = {
  data: PropTypes.shape({
    abTest: PropTypes.string,
    abTestVariation: PropTypes.number,
    title: PropTypes.string.isRequired,
    toSpa: PropTypes.bool.isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
}

export default MobileNavFooterLink
